<template>
  <q-dialog
    v-model="shown"
    data-test-id="released-sections-dialog"
  >
    <q-card
      style="width: 400px;"
      data-test-id="released-sections-dialog-card"
    >
      <q-card-section class="row items-center q-mx-xs">
        <div class="text-h6">
          Release Sections
        </div>
        <q-space />
        <q-btn
          v-close-popup
          icon="close"
          flat
          round
          dense
          data-test-id="released-sections-dialog-close-button"
        />
      </q-card-section>
      <q-card-section>
        <q-list bordered>
          <q-item
            v-for="section in seatChart.heldSeatSectionNames"
            :key="section"
          >
            <q-item-section class="col">
              {{ section }}
            </q-item-section>
            <q-item-section>
              <q-toggle
                :model-value="sectionReleased(section)"
                class="col-auto"
                keep-color
                left-label
                :color="sectionReleased(section) ? 'green' : 'red'"
                unchecked-icon="clear"
                checked-icon="check"
                :label="sectionReleased(section) ? 'Released' : 'Held'"
                data-test-id="released-sections-dialog-toggle"
                @update:model-value="toggleIfAdmin(section)"
                @click.stop
              />
            </q-item-section>
          </q-item>
        </q-list>
      </q-card-section>
    </q-card>
  </q-dialog>
</template>

<script>
import SeatChart from 'src/models/screen/SeatChart'
import Showing from 'src/models/showing/Showing'

export default {
  name: 'ReleasedSectionsDialog',
  props: {
    modelValue: {
      type: Boolean,
      default: false,
      required: false
    },
    showing: {
      type: Showing,
      required: true
    },
    seatChart: {
      type: SeatChart,
      required: true
    }
  },
  emits: ['update:model-value', 'request-authorization'],
  data () {
    return {
      shown: false
    }
  },
  watch: {
    modelValue () {
      this.shown = this.modelValue
    },
    shown () {
      this.$emit('update:model-value', this.shown)
    }
  },
  context: ['currentUser'],
  methods: {
    show () {
      this.shown = true
    },
    sectionReleased (section) {
      return _.includes(this.showing.releasedSections, section)
    },
    toggleIfAdmin (section) {
      if (!this.currentUser.admin) {
        this.$emit('request-authorization', () => { this.toggle(section) })
      } else {
        this.toggle(section)
      }
    },
    async toggle (section) {
      if (this.sectionReleased(section)) {
        this.showing.releasedSections = _.without(this.showing.releasedSections, section)
      } else {
        this.showing.releasedSections ||= []

        this.showing.releasedSections.push(section)
      }
      this.shown = false
      await this.showing.save()
      await this.seatChart.fetch(true)
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
